import { breakpointerLoader } from '../../rankers/components/breakpointer/breakpointer_loader';
breakpointerLoader();

import { reviewLoader } from '../../rankers/components/review/review_loader';
reviewLoader();

import { avatarLoader } from '../../rankers/components/avatar/avatar_loader';
avatarLoader();

import { rankingsSliderLoader } from '../../rankers/components/rankings_slider/rankings_slider_loader';
rankingsSliderLoader();
